declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void;
    }
}

function adsId() {
    return process.env.VUE_APP_GOOGLE_ADS_ID || 'AW-957857141';
}

function sendTo(label: string | undefined) {
    if (!label) {
        return null;
    }

    return `${adsId()}/${label}`;
}

function trackConversion(label: string | undefined, value?: number, currency?: string) {
    const destination = sendTo(label);
    if (!destination || !window.gtag) {
        return false;
    }

    const payload: Record<string, string | number> = {
        send_to: destination
    };

    if (value !== undefined) {
        payload.value = value;
    }

    if (currency) {
        payload.currency = currency;
    }

    window.gtag('event', 'conversion', payload);
    return true;
}

export function trackGoogleAdsRegistration() {
    return trackConversion(process.env.VUE_APP_GOOGLE_ADS_REGISTRATION_LABEL);
}

export function trackGoogleAdsOneOffPurchase(value?: number, currency = 'GBP') {
    return trackConversion(process.env.VUE_APP_GOOGLE_ADS_ONE_OFF_PURCHASE_LABEL, value, currency);
}

export function trackGoogleAdsSubscriptionPurchase(value?: number, currency = 'GBP') {
    return trackConversion(process.env.VUE_APP_GOOGLE_ADS_SUBSCRIPTION_PURCHASE_LABEL, value, currency);
}
